export enum MergeRequestStatus {
    MERGES_WITH_UPDATES = 'merges_with_updates',
    MERGED_NO_UPDATES = 'merges_no_updates',
    OPEN = 'open',
    ABANDONED = 'abandoned',
}
